import FormContainer from "components/form";
import UILayout from "components/layout/UILayout";
import Breadcrumbs from "components/shared/Breadcrumbs";
import { RouterLink } from "components/ui/Link";
import Loading from "components/ui/Loading";
import UILabel from "components/ui/UILabel";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getUsersProfile,
  usePostUsersTransactionSettingsMutation,
} from "store/api/apiSlice";
import styled from "styled-components";
import Form from "./Form";

const Wrapper = styled(UILayout)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding-top: 24px;
`;

const TransactionSettings: React.FC = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();
  const { data: userProfile, isLoading: isLoadingUserProfile } =
    getUsersProfile();
  const [
    postTransactionSettings,
    { isSuccess: isSuccessPostTransactionSettings },
  ] = usePostUsersTransactionSettingsMutation();

  const onSubmit = async (values, { reset }) => {
    postTransactionSettings(values);

    reset({ ...values });
  };

  useEffect(() => {
    if (!isSuccessPostTransactionSettings) return;

    setIsSuccess(isSuccessPostTransactionSettings);

    const timeout = setTimeout(() => {
      setIsSuccess(false);
      navigate("/dashboard", { viewTransition: true });
    }, 500);

    return () => clearTimeout(timeout);
  }, [isSuccessPostTransactionSettings]);

  if (isLoadingUserProfile) return <Loading />;

  return (
    <Wrapper>
      <Breadcrumbs />

      <UILabel.Large>
        Switchboard lets you manage how your debit card pays for transactions.
        Updating your settings here will take effect immediately and impact
        future transactions only.
      </UILabel.Large>

      <FormContainer
        onSubmit={onSubmit}
        defaultValues={{
          transactionSource: userProfile?.currentTransactionSource,
        }}
      >
        <Form isSuccess={isSuccess} />
      </FormContainer>

      <Footer>
        <UILabel.Medium>New to Switchboard?</UILabel.Medium>
        <RouterLink to="/switchboard">Learn more</RouterLink>
      </Footer>
    </Wrapper>
  );
};

export default TransactionSettings;
